export const HEY = 'Hey';
export const SUPPORT_MESSAGE = `Please do not hasitate to contact us\nSend us your message below or contact us on support@fosol.com`;
export const HELP_PLACEHOLDER = 'What can we help you with?';
export const ASK_HELP = 'Ask For Help';



// WEBPACK FOOTER //
// ./src/lang/en/support.js